module.exports = __webpack_public_path__ + "static/des-circle-low.6e5b171c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/des-circle-low.jpg
// module id = 876
// module chunks = 169928946856436